// source: pbtypes/gen/skybus_tunnel/tunnel_channel.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_skybus_tunnel_qos_class_pb = require('../../../pbtypes/gen/skybus_tunnel/qos_class_pb.js');
goog.object.extend(proto, pbtypes_gen_skybus_tunnel_qos_class_pb);
var pbtypes_gen_skybus_tunnel_tunnel_direction_pb = require('../../../pbtypes/gen/skybus_tunnel/tunnel_direction_pb.js');
goog.object.extend(proto, pbtypes_gen_skybus_tunnel_tunnel_direction_pb);
var pbtypes_gen_skybus_tunnel_tunnel_protocol_pb = require('../../../pbtypes/gen/skybus_tunnel/tunnel_protocol_pb.js');
goog.object.extend(proto, pbtypes_gen_skybus_tunnel_tunnel_protocol_pb);
goog.exportSymbol('proto.skybus_tunnel.TunnelChannel', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skybus_tunnel.TunnelChannel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skybus_tunnel.TunnelChannel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skybus_tunnel.TunnelChannel.displayName = 'proto.skybus_tunnel.TunnelChannel';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skybus_tunnel.TunnelChannel.prototype.toObject = function(opt_includeInstance) {
  return proto.skybus_tunnel.TunnelChannel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skybus_tunnel.TunnelChannel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skybus_tunnel.TunnelChannel.toObject = function(includeInstance, msg) {
  var f, obj = {
channel: jspb.Message.getFieldWithDefault(msg, 1, ""),
id: jspb.Message.getFieldWithDefault(msg, 8, 0),
direction: jspb.Message.getFieldWithDefault(msg, 2, 0),
downsampleNominalDt: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
downsampleLowThrottleDt: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
protocol: jspb.Message.getFieldWithDefault(msg, 4, 0),
qos: jspb.Message.getFieldWithDefault(msg, 6, 0),
fecCodeRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skybus_tunnel.TunnelChannel}
 */
proto.skybus_tunnel.TunnelChannel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skybus_tunnel.TunnelChannel;
  return proto.skybus_tunnel.TunnelChannel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skybus_tunnel.TunnelChannel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skybus_tunnel.TunnelChannel}
 */
proto.skybus_tunnel.TunnelChannel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setChannel(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.skybus_tunnel.TunnelDirection.Enum} */ (reader.readEnum());
      msg.setDirection(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDownsampleNominalDt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDownsampleLowThrottleDt(value);
      break;
    case 4:
      var value = /** @type {!proto.skybus_tunnel.TunnelProtocol.Enum} */ (reader.readEnum());
      msg.setProtocol(value);
      break;
    case 6:
      var value = /** @type {!proto.skybus_tunnel.QosClass.Enum} */ (reader.readEnum());
      msg.setQos(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFecCodeRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skybus_tunnel.TunnelChannel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skybus_tunnel.TunnelChannel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skybus_tunnel.TunnelChannel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skybus_tunnel.TunnelChannel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDownsampleNominalDt();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getDownsampleLowThrottleDt();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getProtocol();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getQos();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getFecCodeRate();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
};


/**
 * optional string channel = 1;
 * @return {string}
 */
proto.skybus_tunnel.TunnelChannel.prototype.getChannel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.skybus_tunnel.TunnelChannel} returns this
 */
proto.skybus_tunnel.TunnelChannel.prototype.setChannel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 id = 8;
 * @return {number}
 */
proto.skybus_tunnel.TunnelChannel.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.skybus_tunnel.TunnelChannel} returns this
 */
proto.skybus_tunnel.TunnelChannel.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional TunnelDirection.Enum direction = 2;
 * @return {!proto.skybus_tunnel.TunnelDirection.Enum}
 */
proto.skybus_tunnel.TunnelChannel.prototype.getDirection = function() {
  return /** @type {!proto.skybus_tunnel.TunnelDirection.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.skybus_tunnel.TunnelDirection.Enum} value
 * @return {!proto.skybus_tunnel.TunnelChannel} returns this
 */
proto.skybus_tunnel.TunnelChannel.prototype.setDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional float downsample_nominal_dt = 3;
 * @return {number}
 */
proto.skybus_tunnel.TunnelChannel.prototype.getDownsampleNominalDt = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skybus_tunnel.TunnelChannel} returns this
 */
proto.skybus_tunnel.TunnelChannel.prototype.setDownsampleNominalDt = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float downsample_low_throttle_dt = 5;
 * @return {number}
 */
proto.skybus_tunnel.TunnelChannel.prototype.getDownsampleLowThrottleDt = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skybus_tunnel.TunnelChannel} returns this
 */
proto.skybus_tunnel.TunnelChannel.prototype.setDownsampleLowThrottleDt = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional TunnelProtocol.Enum protocol = 4;
 * @return {!proto.skybus_tunnel.TunnelProtocol.Enum}
 */
proto.skybus_tunnel.TunnelChannel.prototype.getProtocol = function() {
  return /** @type {!proto.skybus_tunnel.TunnelProtocol.Enum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.skybus_tunnel.TunnelProtocol.Enum} value
 * @return {!proto.skybus_tunnel.TunnelChannel} returns this
 */
proto.skybus_tunnel.TunnelChannel.prototype.setProtocol = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional QosClass.Enum qos = 6;
 * @return {!proto.skybus_tunnel.QosClass.Enum}
 */
proto.skybus_tunnel.TunnelChannel.prototype.getQos = function() {
  return /** @type {!proto.skybus_tunnel.QosClass.Enum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.skybus_tunnel.QosClass.Enum} value
 * @return {!proto.skybus_tunnel.TunnelChannel} returns this
 */
proto.skybus_tunnel.TunnelChannel.prototype.setQos = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional float fec_code_rate = 7;
 * @return {number}
 */
proto.skybus_tunnel.TunnelChannel.prototype.getFecCodeRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skybus_tunnel.TunnelChannel} returns this
 */
proto.skybus_tunnel.TunnelChannel.prototype.setFecCodeRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


goog.object.extend(exports, proto.skybus_tunnel);
